import type { LinkItemDto } from '@/lib/sanity/dto';
import { stegaClean } from '@/lib/utils/stega';

export function hasLinkTarget(item?: LinkItemDto | null): boolean {
    if (!item) return false;

    if (item.linkType === 'external') {
        const href = item.href ? stegaClean(item.href).trim() : '';
        return !!href;
    }

    const slug = item.page?.slug ? stegaClean(item.page.slug).trim() : '';
    const anchor = item.anchor ? stegaClean(item.anchor).trim() : '';

    return !!(slug || anchor);
}

export function resolveHref(item: LinkItemDto): string {
    if (item.linkType === 'external') {
        const href = item.href ? stegaClean(item.href).trim() : '';
        return href ?? '#';
    }

    const pageSlug = item.page?.slug ? stegaClean(item.page.slug).trim() : '';
    const base = pageSlug ? `/${pageSlug}` : '/';

    if (item.openInModal) {
        return `/m${base}`;
    }

    const anchor = item.anchor ? stegaClean(item.anchor).trim() : '';
    if (anchor) {
        return `${base}#${anchor}`;
    }

    return base;
}

export function normalizePath(path: string) {
    if (path.length > 1 && path.endsWith('/')) {
        return path.slice(0, -1);
    }
    return path;
}

export function getAnchorId(href: string): string | null {
    const i = href.indexOf('#');
    return i === -1 ? null : href.slice(i + 1) || null;
}

export function getAnchorIds(items: LinkItemDto[]): string[] {
    const ids = items.map((item) => getAnchorId(resolveHref(item))).filter((id): id is string => Boolean(id));

    return Array.from(new Set(ids));
}
